/**
 * What actually happens to a file, said plainly, where the designer is deciding.
 *
 * NOT DECORATION. This importer sends the file somewhere — there is no in-browser engine for
 * these formats — so every sentence is a specific promise rather than reassurance.
 * `office-to-design` carries the same note and a test that reads its source back to check each
 * claim still holds; this app has none, which makes the wording something to change only
 * alongside the behaviour it describes.
 */

import { Text } from '@figma-importers/ui';

export function CreatorsNote() {
  return (
    <Text fontSize="xs" color="figma.textMuted" lineHeight="snug">
      <Text as="span" fontWeight="600" color="figma.textSecondary">
        Creator&rsquo;s note:
      </Text>{' '}
      your file is converted on our own server and is never stored in readable form. The
      filename never leaves your browser — only the file extension is sent. Converted results
      are cached encrypted with a key derived from your own document and expire within 24
      hours. PDFs are converted entirely in your browser and never uploaded. Your Figma account
      id is sent to our licence server to check your plan and count free imports. Anonymous
      usage metrics (format, duration, success) are recorded; no filenames, no document
      contents, no IP addresses.
    </Text>
  );
}
